import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { MuiPickersAdapterContext } from '../../../LocalizationProvider';

// Required for babel https://github.com/vercel/next.js/issues/7882. Replace with `export type` in future

function useLocalizationContext() {
  var localization = React.useContext(MuiPickersAdapterContext);
  if (localization === null) {
    throw Error('Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly.');
  }
  return localization;
}
export function useUtils() {
  return _objectSpread(_objectSpread({}, useLocalizationContext().utils), {}, {
    addYears: function addYears(day, number) {
      return day === null || day === void 0 ? void 0 : day.add(number, 'years');
    },
    startOfYear: function startOfYear(day) {
      return day === null || day === void 0 ? void 0 : day.startOf('year');
    },
    endOfYear: function endOfYear(day) {
      return day === null || day === void 0 ? void 0 : day.endOf('year');
    }
  });
}
export function useDefaultDates() {
  return useLocalizationContext().defaultDates;
}
export function useNow() {
  var utils = useUtils();
  var now = React.useRef(utils.date());
  return now.current;
}